import { Box, Grid, InputLabel, TextField, Select, MenuItem, Button, Chip, Autocomplete, FormControl, FormHelperText, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from "../../../../shared/context/authContext";
import { useEffect } from "react";

export default function CrearPermisosComponent() {
    const { permission, setPermission, sections, loadingGetSections, getAllSections, loadingCreatePermission, createPermissionByRole, loadingUpdatePermission, updatePermissionByRole } = useAuth();
    const { control, handleSubmit, setValue, watch, formState: { errors } } = useForm({
        defaultValues: {
            name: '',
            section_hash_code: '',
            actions: []
        }
    });

   

    // Watch form values
    const formValues = {
        name: watch('name'),
        section_hash_code: watch('section_hash_code'),
        actions: watch('actions')
    };

    useEffect(() => {
        getAllSections();
    }, []);

    // Solo cargar datos cuando hay un ID y es la primera vez
    useEffect(() => {
        if (permission.id) {
            setValue('name', permission.name || '');
            setValue('section_hash_code', permission.section_hash_code || '');
            setValue('actions', permission.actions || []);
        }
    }, [permission.id]); // Solo se ejecuta cuando cambia el ID

    const onSubmit = (data) => {
        if (permission.id) {
            updatePermissionByRole({ ...data, id: permission.id });
        } else {
            createPermissionByRole(data);
        }
    }

    return (
        <Box sx={{
            padding: '20px',
        }}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ color: 'text.primary', fontWeight: 'bold' }}>Nombre del permiso</InputLabel>
                    <Typography variant="body2" color="text.secondary">
                      Agrega un nombre que identifique el permiso.
                    </Typography>
                    <Controller
                        control={control}
                        name="name"
                        rules={{ required: 'El nombre del permiso es requerido' }}
                        render={({ field }) => (
                            <TextField 
                                {...field}
                                fullWidth 
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ color: 'text.primary', fontWeight: 'bold' }}>Selecciona el módulo</InputLabel>
                    <Typography variant="body2" color="text.secondary">
                        Módulo: corresponde a la sección del sistema que se está creando el permiso.
                    </Typography>
                    <FormControl fullWidth>
                    <Controller
                        control={control}
                        name="section_hash_code"
                        rules={{ required: 'El módulo es requerido' }}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={sections || []}
                                getOptionLabel={(option) => option?.name || ''}
                                loading={loadingGetSections}
                                onOpen={() => getAllSections()}
                                onChange={(_, newValue) => field.onChange(newValue)}
                                onInputChange={(_, newInputValue) => {
                                    getAllSections({ name: newInputValue });
                                }}
                                isOptionEqualToValue={(option, value) => 
                                    option?.id === value?.id
                                }
                                fullWidth
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        required 
                                        error={!!errors.section_hash_code}
                                        helperText={errors.section_hash_code?.message}
                                        placeholder="Buscar módulo..."
                                    />
                                )}
                            />
                        )}
                    />
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ color: 'text.primary', fontWeight: 'bold' }}>Acciones dentro del módulo</InputLabel>
                    <FormControl fullWidth>
                    <Controller
                        control={control}
                        name="actions"
                        rules={{ required: 'Las acciones son requeridas' }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                fullWidth
                                multiple
                                error={!!errors.actions}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const label = {
                                                'create': 'Crear',
                                                'update': 'Editar', 
                                                'delete': 'Eliminar',
                                                'read': 'Ver'
                                            }[value];
                                            return <Chip key={value} label={label} />
                                        })}
                                    </Box>
                                )}
                            >
                                <MenuItem value="create">Crear</MenuItem>
                                <MenuItem value="update">Editar</MenuItem>
                                <MenuItem value="delete">Eliminar</MenuItem>
                                <MenuItem value="read">Ver</MenuItem>
                            </Select>
                        )}
                    />
                    {errors.actions && <FormHelperText error>{errors.actions.message}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <Button 
                        type="submit" 
                        disabled={loadingCreatePermission || loadingUpdatePermission} 
                        startIcon={<SaveIcon />} 
                        variant="contained" 
                        color="primary"
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
            </form>
        </Box>
    )
}